import React from 'react';
import { 
  Shield, FileText, CreditCard, Users, Lock, 
  AlertCircle, CheckCircle, BookOpen, Scale,
  Building, Phone, Mail, MapPin, Clock,
  ChevronRight, Info, Award, Briefcase, MessageCircle
} from 'lucide-react';
import CorporateFooter from '../components/CorporateFooter';
import WhatsAppWidget from '../components/WhatsAppWidget';

const Terms = () => {
  const [showLibroReclamaciones, setShowLibroReclamaciones] = React.useState(false);
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800">
      {/* Header Corporativo */}
      <header className="bg-white dark:bg-gray-800 shadow-lg sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center shadow-lg">
                <span className="text-2xl font-bold text-white">M</span>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                  MediExamPro
                </h1>
                <p className="text-xs text-gray-600 dark:text-gray-400">Preparación Médica Premium</p>
              </div>
            </div>
            <nav className="hidden md:flex items-center gap-6">
              <a href="/" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 transition-colors">
                Inicio
              </a>
              <a href="/precios" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 transition-colors">
                Planes
              </a>
              <a href="/terminos" className="text-blue-600 font-semibold border-b-2 border-blue-600 pb-1">
                Términos
              </a>
              <a href="/privacidad" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 transition-colors">
                Privacidad
              </a>
              <a href="/devoluciones" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 transition-colors">
                Devoluciones
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-3 mb-4">
            <Scale className="h-8 w-8" />
            <h1 className="text-4xl font-bold">Términos y Condiciones</h1>
          </div>
          <p className="text-xl text-blue-100">Marco legal que rige el uso de MediExamPro</p>
          <div className="mt-6 flex flex-wrap gap-4">
            <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-lg">
              <Shield className="h-5 w-5" />
              <span>Protección al consumidor</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-lg">
              <Lock className="h-5 w-5" />
              <span>Datos seguros</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-lg">
              <Award className="h-5 w-5" />
              <span>Garantía de satisfacción</span>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Sidebar con información importante */}
          <div className="lg:col-span-1">
            <div className="sticky top-24 space-y-6">
              {/* Información de la empresa */}
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6">
                <h3 className="font-bold text-lg mb-4 flex items-center gap-2">
                  <Building className="h-5 w-5 text-blue-600" />
                  Información Legal
                </h3>
                <div className="space-y-3 text-sm">
                  <div>
                    <p className="text-gray-600 dark:text-gray-400">Razón Social:</p>
                    <p className="font-semibold">GARCIA CASUSOL CESAR ALEXIS</p>
                  </div>
                  <div>
                    <p className="text-gray-600 dark:text-gray-400">RUC:</p>
                    <p className="font-semibold">10709315302</p>
                  </div>
                  <div>
                    <p className="text-gray-600 dark:text-gray-400">Domicilio Fiscal:</p>
                    <p className="font-semibold">Lima, Perú</p>
                  </div>
                </div>
              </div>

              {/* Contacto rápido */}
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 rounded-xl p-6">
                <h3 className="font-bold text-lg mb-4 flex items-center gap-2">
                  <Phone className="h-5 w-5 text-blue-600" />
                  Contacto Directo
                </h3>
                <div className="space-y-3">
                  <a href="mailto:mediexampro@gmail.com" className="flex items-center gap-2 text-sm hover:text-blue-600">
                    <Mail className="h-4 w-4" />
                    mediexampro@gmail.com
                  </a>
                  <a href="tel:+51964088671" className="flex items-center gap-2 text-sm hover:text-blue-600">
                    <Phone className="h-4 w-4" />
                    +51 964 088 671
                  </a>
                  <a href="https://wa.me/51997268543" className="flex items-center gap-2 text-sm hover:text-green-600">
                    <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.149-.67.149-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                    WhatsApp: +51 997 268 543
                  </a>
                </div>
              </div>

              {/* Seguridad */}
              <div className="bg-green-50 dark:bg-green-900/20 rounded-xl p-6">
                <h3 className="font-bold text-lg mb-4 flex items-center gap-2 text-green-700 dark:text-green-400">
                  <Shield className="h-5 w-5" />
                  Seguridad Garantizada
                </h3>
                <ul className="space-y-2 text-sm">
                  <li className="flex items-start gap-2">
                    <CheckCircle className="h-4 w-4 text-green-600 mt-0.5" />
                    <span>SSL 256-bit encryption</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="h-4 w-4 text-green-600 mt-0.5" />
                    <span>Pagos procesados por Culqi</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="h-4 w-4 text-green-600 mt-0.5" />
                    <span>Datos protegidos por ley</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contenido principal */}
          <div className="lg:col-span-2">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
              <div className="mb-8">
                <div className="flex items-center justify-between mb-6">
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    Última actualización: {new Date().toLocaleDateString('es-PE', { 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}
                  </p>
                  <span className="bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400 px-3 py-1 rounded-full text-sm font-medium">
                    Versión 2.0
                  </span>
                </div>
                
                <div className="bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-600 p-4 rounded-r-lg mb-8">
                  <div className="flex items-start gap-3">
                    <Info className="h-5 w-5 text-blue-600 mt-0.5" />
                    <div>
                      <p className="font-semibold text-blue-900 dark:text-blue-300 mb-1">
                        Aviso Importante
                      </p>
                      <p className="text-sm text-blue-800 dark:text-blue-400">
                        Al utilizar MediExamPro, usted acepta estos términos y condiciones en su totalidad. 
                        Le recomendamos leer detenidamente este documento antes de realizar cualquier compra.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">1</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Identificación del Proveedor
                  </h2>
                </div>
                <div className="bg-gray-50 dark:bg-gray-900/50 rounded-lg p-6 space-y-3">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Nombre Comercial:</p>
                      <p className="font-semibold">MediExamPro</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Razón Social:</p>
                      <p className="font-semibold">GARCIA CASUSOL CESAR ALEXIS</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">RUC:</p>
                      <p className="font-semibold">10709315302</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Domicilio Fiscal:</p>
                      <p className="font-semibold">Lima, Perú</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Correo Electrónico:</p>
                      <p className="font-semibold">mediexampro@gmail.com</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Teléfono:</p>
                      <p className="font-semibold">+51 964 088 671</p>
                    </div>
                  </div>
                </div>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">2</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Aceptación de los Términos
                  </h2>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Al acceder, navegar y/o utilizar MediExamPro, el usuario acepta haber leído, 
                  entendido y estar de acuerdo con estos términos y condiciones. Si no está de 
                  acuerdo con estos términos, debe abstenerse de utilizar la plataforma.
                </p>
                <div className="bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-500 p-4 rounded-r-lg">
                  <p className="text-sm text-yellow-800 dark:text-yellow-300">
                    <strong>Capacidad Legal:</strong> El usuario declara tener capacidad legal para 
                    contratar y no estar prohibido o inhabilitado legal o administrativamente para 
                    contratar con el Estado Peruano.
                  </p>
                </div>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">3</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Descripción del Servicio
                  </h2>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-6">
                  MediExamPro es una plataforma digital educativa especializada en la preparación 
                  integral para el Examen Nacional de Aspirantes a Residencias Médicas (ENARM) y el examen de residentado 
                  médico en Perú.
                </p>
                
                <div className="grid md:grid-cols-2 gap-4 mb-6">
                  <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
                    <h4 className="font-semibold mb-2 flex items-center gap-2">
                      <BookOpen className="h-5 w-5 text-blue-600" />
                      Características Base
                    </h4>
                    <ul className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
                      <li className="flex items-start gap-2">
                        <ChevronRight className="h-4 w-4 text-blue-500 mt-0.5" />
                        <span>+1,200 preguntas actualizadas</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <ChevronRight className="h-4 w-4 text-blue-500 mt-0.5" />
                        <span>Múltiples especialidades médicas</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <ChevronRight className="h-4 w-4 text-blue-500 mt-0.5" />
                        <span>Explicaciones detalladas</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <ChevronRight className="h-4 w-4 text-blue-500 mt-0.5" />
                        <span>Referencias bibliográficas</span>
                      </li>
                    </ul>
                  </div>
                  
                  <div className="bg-green-50 dark:bg-green-900/20 rounded-lg p-4">
                    <h4 className="font-semibold mb-2 flex items-center gap-2">
                      <Award className="h-5 w-5 text-green-600" />
                      Características Premium
                    </h4>
                    <ul className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
                      <li className="flex items-start gap-2">
                        <ChevronRight className="h-4 w-4 text-green-500 mt-0.5" />
                        <span>Simulacros con temporizador</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <ChevronRight className="h-4 w-4 text-green-500 mt-0.5" />
                        <span>Análisis predictivo con IA</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <ChevronRight className="h-4 w-4 text-green-500 mt-0.5" />
                        <span>Descarga PDF/TXT</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <ChevronRight className="h-4 w-4 text-green-500 mt-0.5" />
                        <span>Estadísticas avanzadas</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">4</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Planes y Tarifas
                  </h2>
                </div>
                <div className="text-gray-700 dark:text-gray-300 mb-4">
                  <h3 className="font-semibold mb-2">Periodo de Prueba (3 días GRATIS):</h3>
                  <ul className="list-disc list-inside ml-4 mb-4">
                    <li>20 preguntas por examen durante el trial</li>
                    <li>Acceso a todas las especialidades</li>
                    <li>Banco de errores personalizado</li>
                    <li>Estadísticas básicas de rendimiento</li>
                    <li>Seguimiento de progreso por especialidad</li>
                    <li>Acceso desde cualquier dispositivo</li>
                    <li>Notificaciones por email sobre el estado del trial</li>
                  </ul>

                  <h3 className="font-semibold mb-2">Después del Trial:</h3>
                  <ul className="list-disc list-inside ml-4 mb-4">
                    <li>Acceso completamente bloqueado</li>
                    <li>No se pueden generar exámenes</li>
                    <li>Se mantiene el historial de progreso</li>
                    <li>Necesario actualizar a Plan PRO para continuar</li>
                  </ul>

                  <h3 className="font-semibold mb-2">Plan PRO (S/ 39.90/mes):</h3>
                  <ul className="list-disc list-inside ml-4 mb-4">
                    <li>Preguntas ILIMITADAS de toda la base de datos</li>
                    <li>Modo SIMULACRO con temporizador como el examen real</li>
                    <li>Descargas en PDF y TXT de tus exámenes</li>
                    <li>Estadísticas avanzadas y análisis detallado</li>
                    <li>Banco de errores avanzado con explicaciones</li>
                    <li>Historial completo de todos tus exámenes</li>
                    <li>Acceso prioritario a nuevas funcionalidades</li>
                    <li>Soporte técnico prioritario</li>
                    <li>Sin restricciones de ningún tipo</li>
                  </ul>
                </div>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">5</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Proceso de Pago y Facturación
                  </h2>
                </div>
                <div className="bg-gray-50 dark:bg-gray-900/50 rounded-lg p-6 mb-6">
                  <h4 className="font-semibold mb-3 flex items-center gap-2">
                    <CreditCard className="h-5 w-5 text-blue-600" />
                    Métodos de Pago Aceptados
                  </h4>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                    <div className="bg-white dark:bg-gray-800 p-3 rounded-lg text-center">
                      <p className="font-medium text-sm">Visa</p>
                    </div>
                    <div className="bg-white dark:bg-gray-800 p-3 rounded-lg text-center">
                      <p className="font-medium text-sm">Mastercard</p>
                    </div>
                    <div className="bg-white dark:bg-gray-800 p-3 rounded-lg text-center">
                      <p className="font-medium text-sm">American Express</p>
                    </div>
                    <div className="bg-white dark:bg-gray-800 p-3 rounded-lg text-center">
                      <p className="font-medium text-sm">Diners Club</p>
                    </div>
                    <div className="bg-white dark:bg-gray-800 p-3 rounded-lg text-center">
                      <p className="font-medium text-sm">Yape</p>
                    </div>
                    <div className="bg-white dark:bg-gray-800 p-3 rounded-lg text-center">
                      <p className="font-medium text-sm">Plin</p>
                    </div>
                  </div>
                </div>
                
                <div className="space-y-4 text-gray-700 dark:text-gray-300">
                  <p>
                    <strong>Procesador de Pagos:</strong> Todos los pagos son procesados de forma 
                    segura a través de Culqi, cumpliendo con los estándares PCI DSS.
                  </p>
                  <p>
                    <strong>Renovación Automática:</strong> Las suscripciones mensuales se renuevan 
                    automáticamente. Puede cancelar en cualquier momento desde su panel de usuario, 
                    con efecto al final del período de facturación actual.
                  </p>
                  <p>
                    <strong>Comprobantes:</strong> Se emitirán boletas o facturas electrónicas según 
                    lo solicitado por el usuario, conforme a la normativa tributaria peruana.
                  </p>
                </div>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">6</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Política de Uso Aceptable
                  </h2>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Usted se compromete a:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 ml-4 mb-4">
                  <li>No compartir su cuenta con terceros</li>
                  <li>No copiar o redistribuir el contenido</li>
                  <li>No usar el servicio para fines ilegales</li>
                  <li>No intentar hackear o comprometer la seguridad del sistema</li>
                  <li>Mantener la confidencialidad de sus credenciales</li>
                </ul>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">7</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Propiedad Intelectual
                  </h2>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Todo el contenido de MediExamPro, incluyendo preguntas, explicaciones, diseño y código, está protegido por derechos de autor. El uso no autorizado está prohibido.
                </p>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">8</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Política de Devolución y Reembolso
                  </h2>
                </div>
                <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-6">
                  <div className="flex items-start gap-3 mb-4">
                    <CheckCircle className="h-6 w-6 text-green-600 mt-0.5" />
                    <div>
                      <h4 className="font-semibold text-green-900 dark:text-green-300 mb-2">
                        Garantía de Satisfacción de 7 Días
                      </h4>
                      <p className="text-gray-700 dark:text-gray-300 text-sm">
                        Si no está completamente satisfecho con MediExamPro, puede solicitar un 
                        reembolso completo dentro de los primeros 7 días calendario desde la fecha 
                        de su primera suscripción de pago.
                      </p>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    Para más detalles, consulte nuestra{' '}
                    <a href="/devoluciones" className="text-blue-600 hover:underline font-medium">
                      Política de Devoluciones completa
                    </a>.
                  </p>
                </div>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">9</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Limitación de Responsabilidad
                  </h2>
                </div>
                <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-6">
                  <div className="flex items-start gap-3">
                    <AlertCircle className="h-5 w-5 text-yellow-600 mt-0.5" />
                    <div className="text-sm text-gray-700 dark:text-gray-300 space-y-3">
                      <p>
                        <strong>Naturaleza del Servicio:</strong> MediExamPro es una herramienta 
                        educativa complementaria. No sustituye la formación médica formal ni 
                        garantiza resultados específicos en exámenes oficiales.
                      </p>
                      <p>
                        <strong>Responsabilidad del Usuario:</strong> El usuario es el único 
                        responsable de su preparación integral y de los resultados obtenidos 
                        en sus evaluaciones.
                      </p>
                      <p>
                        <strong>Límites de Responsabilidad:</strong> En ningún caso MediExamPro 
                        será responsable por daños indirectos, incidentales, especiales o 
                        consecuenciales que resulten del uso o la imposibilidad de uso del servicio.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">10</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Protección de Datos Personales
                  </h2>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  MediExamPro se compromete a proteger la privacidad y los datos personales de sus 
                  usuarios conforme a la Ley N° 29733 - Ley de Protección de Datos Personales del Perú.
                </p>
                <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
                  <ul className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
                    <li className="flex items-start gap-2">
                      <Lock className="h-4 w-4 text-blue-600 mt-0.5" />
                      <span>Los datos personales son tratados con total confidencialidad</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <Lock className="h-4 w-4 text-blue-600 mt-0.5" />
                      <span>No compartimos información con terceros sin consentimiento</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <Lock className="h-4 w-4 text-blue-600 mt-0.5" />
                      <span>Implementamos medidas de seguridad técnicas y organizativas</span>
                    </li>
                  </ul>
                </div>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-4">
                  Para más información, consulte nuestra{' '}
                  <a href="/privacidad" className="text-blue-600 hover:underline font-medium">
                    Política de Privacidad completa
                  </a>.
                </p>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">11</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Libro de Reclamaciones
                  </h2>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Conforme al Código de Protección y Defensa del Consumidor (Ley N° 29571), 
                  ponemos a disposición nuestro Libro de Reclamaciones virtual para atender 
                  cualquier reclamo o queja.
                </p>
                <a 
                  href="/libro-reclamaciones"
                  className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
                >
                  <FileText className="h-5 w-5" />
                  Acceder al Libro de Reclamaciones
                </a>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">12</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Modificaciones a los Términos
                  </h2>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios serán notificados por email con 30 días de anticipación.
                </p>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">13</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Resolución de Controversias
                  </h2>
                </div>
                <div className="space-y-4 text-gray-700 dark:text-gray-300">
                  <p>
                    <strong>Negociación Directa:</strong> Las partes intentarán resolver cualquier 
                    controversia mediante negociación directa de buena fe.
                  </p>
                  <p>
                    <strong>Mediación:</strong> De no llegar a un acuerdo, las partes podrán someter 
                    la controversia a mediación ante el Centro de Arbitraje de la Cámara de Comercio 
                    de Lima.
                  </p>
                  <p>
                    <strong>Jurisdicción:</strong> Cualquier controversia que no pueda resolverse 
                    mediante los métodos anteriores será sometida a la jurisdicción de los tribunales 
                    del distrito judicial de Lima, Perú.
                  </p>
                </div>
              </section>

              <section className="mb-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                    <span className="text-blue-600 font-bold">14</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Información de Contacto
                  </h2>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-xl p-6">
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Para cualquier consulta, reclamo o sugerencia sobre estos términos y condiciones, 
                    puede contactarnos a través de los siguientes medios:
                  </p>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-3">
                      <h5 className="font-semibold text-gray-900 dark:text-white">Canales Digitales</h5>
                      <div className="space-y-2 text-sm">
                        <a href="mailto:mediexampro@gmail.com" className="flex items-center gap-2 text-gray-700 dark:text-gray-300 hover:text-blue-600">
                          <Mail className="h-4 w-4" />
                          mediexampro@gmail.com
                        </a>
                        <a href="https://wa.me/51997268543" className="flex items-center gap-2 text-gray-700 dark:text-gray-300 hover:text-green-600">
                          <MessageCircle className="h-4 w-4" />
                          WhatsApp: +51 997 268 543
                        </a>
                        <a href="tel:+51964088671" className="flex items-center gap-2 text-gray-700 dark:text-gray-300 hover:text-blue-600">
                          <Phone className="h-4 w-4" />
                          Teléfono: +51 964 088 671
                        </a>
                      </div>
                    </div>
                    <div className="space-y-3">
                      <h5 className="font-semibold text-gray-900 dark:text-white">Información Legal</h5>
                      <div className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
                        <p className="flex items-center gap-2">
                          <Building className="h-4 w-4" />
                          RUC: 10709315302
                        </p>
                        <p className="flex items-center gap-2">
                          <Briefcase className="h-4 w-4" />
                          GARCIA CASUSOL CESAR ALEXIS
                        </p>
                        <p className="flex items-center gap-2">
                          <MapPin className="h-4 w-4" />
                          Lima, Perú
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 pt-4 border-t border-blue-200 dark:border-blue-800">
                    <p className="text-xs text-gray-600 dark:text-gray-400 flex items-center gap-2">
                      <Clock className="h-4 w-4" />
                      Horario de atención: Lun-Vie 9:00 AM - 6:00 PM | Sáb 9:00 AM - 1:00 PM
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Corporativo */}
      <CorporateFooter onOpenLibroReclamaciones={() => setShowLibroReclamaciones(true)} />
      
      {/* WhatsApp Widget */}
      <WhatsAppWidget />
      
      {/* Modal de Libro de Reclamaciones */}
      {showLibroReclamaciones && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-800 rounded-xl max-w-4xl w-full max-h-[90vh] overflow-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold">Libro de Reclamaciones</h2>
                <button
                  onClick={() => setShowLibroReclamaciones(false)}
                  className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
                >
                  ✕
                </button>
              </div>
              {/* Aquí iría el componente LibroReclamaciones */}
              <p>Componente de Libro de Reclamaciones</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Terms;